export default [
    'login@/api/login', //登录接口
    'loginCode@/api/login?action=loginUsingIdentityKey'
    // function saveDoctor(req, config) {
    //     return req.post('/doctorcheck-doctorcheck-index.html', {
    //         id: 'doctor',
    //     }, config)
    // }
]